export const CREATE_DATE_PLACEHOLDER = 'CREATE_DATE_PLACEHOLDER';
export const LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID = 'LOAD_DATE_PLACEHOLDERS_BY_BOOK_ID';
export const ASSIGN_IMAGE_TO_PLACEHOLDER = 'ASSIGN_IMAGE_TO_PLACEHOLDER';




// WEBPACK FOOTER //
// ./src/redux/action-types/entities/datePlaceholders.js